import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { isTokenExpired } from "./utils/TokenUtils";
import reportWebVitals from './reportWebVitals';
import Swal from "sweetalert2";

// Check token expiry before rendering the app
const token = localStorage.getItem("authToken");
if (token && isTokenExpired(token)) {
  localStorage.removeItem("authToken");
  localStorage.removeItem("userId");
  //alert("Session expired. Please log in again.");
  Swal.fire({
	  icon: "error",
	  title: "Expired", 
	  text: "Session expired. Please log in again.",
	  cancelButtonColor: "#e83333",
	  cancelButtonText: "Cancel",
	});
  window.location.href = "/home";
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
